import {
  type AutocompleteRenderGroupParams,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import { capitalize } from 'lodash';
import NextLink from 'next/link';
import {
  TrackHomePageEvent,
  useTrackHomePageAnalytics,
} from '$analytics/useTrackAnalytics/domains/homePage';

interface Props extends AutocompleteRenderGroupParams {
  searchValue: string;
  total: number;
}

export const DropdownGroup = ({
  children: dropdownOptions,
  group,
  searchValue,
  total,
}: Props) => {
  const trackEvent = useTrackHomePageAnalytics();

  return (
    <Stack sx={{ pt: 1.25, pb: 1 }}>
      <Stack
        direction="row"
        sx={{ justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Typography variant="subtitle2" sx={{ pl: 2, color: 'text.secondary' }}>
          {capitalize(group.slice(0, -1))}
        </Typography>
        {total > 3 && (
          <Button
            id={`view-all-${group}-link`}
            LinkComponent={NextLink}
            href={`/${group}?search=${searchValue}`}
            sx={{ pl: 1 }}
            onClick={() => {
              trackEvent(TrackHomePageEvent.SearchResultGroupSelection, {
                numResult: total,
                interactionType: group,
              });
            }}
          >{`View all ${total} ${capitalize(group)}`}</Button>
        )}
      </Stack>
      {dropdownOptions}
    </Stack>
  );
};
